import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Reusable dark CTA banner — appears on every page footer area.
 */
const CTABanner = ({
  eyebrow = "Get started",
  title = "Book a free 30-minute discovery.",
  body = "Bring one challenge. Leave with three prioritised next steps and a clear view of whether (and how) Ekselens can help. No slide pitch, no obligation.",
}) => {
  return (
    <section className="ek-gradient-dark text-white relative overflow-hidden" data-testid="cta-banner">
      <div className="ek-star-watermark" />
      <div className="ek-vignette-top" />
      <div className="ek-container relative z-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="ek-eyebrow text-[#A179FA]">{eyebrow}</div>
            <h2 className="ek-heading text-white text-4xl md:text-5xl lg:text-6xl mt-4">
              {title}
            </h2>
            <p className="text-zinc-300 font-light text-lg leading-relaxed mt-6 max-w-2xl">
              {body}
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link to="/contact" className="ek-btn ek-btn-primary text-base px-7 py-4" data-testid="cta-banner-button">
              Book a discovery conversation <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
